





















import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import Checkbox from "../form/checkBox.vue";

@Component({
  components: { Checkbox },
})
export default class LegalLinks extends Vue {
  @Emit("input")
  onChange(val: any) {
    return val;
  }
}
